import { writable } from "svelte/store";

export const viewTour = writable(null);

export function registerViewTour(start) {
  const tour = { start };
  viewTour.set(tour);
  return () => {
    viewTour.update((current) => current === tour ? null : current);
  };
}
